import { lazy, FC, Suspense } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { MasterLayout } from "../../_metronic/layout/MasterLayout";
import TopBarProgress from "react-topbar-progress-indicator";
import { DashboardWrapper } from "../pages/dashboard/DashboardWrapper";
import { MenuTestPage } from "../pages/MenuTestPage";
import { getCSSVariableValue } from "../../_metronic/assets/ts/_utils";

const PrivateRoutes = () => {
  const BuilderPageWrapper = lazy(
    () => import("../pages/layout-builder/BuilderPageWrapper")
  );
  const MandirCURD = lazy(() => import("../modules/mandir-curd/mandir-curd"));
  const Menu = lazy(() => import("../modules/menu/menu-curd"));
  const User = lazy(() => import("../modules/user/curd"));
  const SatsangiUserCURD = lazy(
    () => import("../modules/satsangi-curd/satsangi-curd")
  );
  const VerificationModule = lazy(
    () => import("../modules/verification/verification-module")
  );

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path="auth/*" element={<Navigate to="/dashboard" />} />
        {/* Pages */}
        <Route path="dashboard" element={<DashboardWrapper />} />
        <Route path="builder" element={<BuilderPageWrapper />} />
        <Route path="menu-test" element={<MenuTestPage />} />
        {/* Lazy Modules */}
        <Route
          path="menu/*"
          element={
            <SuspensedView>
              <Menu />
            </SuspensedView>
          }
        />

        <Route
          path="mandir/*"
          element={
            <SuspensedView>
              <MandirCURD />
            </SuspensedView>
          }
        />

        <Route
          path="user/*"
          element={
            <SuspensedView>
              <User />
            </SuspensedView>
          }
        />
        <Route
          path="satsangi/*"
          element={
            <SuspensedView>
              <SatsangiUserCURD />
            </SuspensedView>
          }
        />
        <Route
          path="verification/*"
          element={
            <SuspensedView>
              <VerificationModule />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path="*" element={<Navigate to="/error/404" />} />
      </Route>
    </Routes>
  );
};

const SuspensedView: FC = ({ children }) => {
  const baseColor = getCSSVariableValue("--bs-primary");
  TopBarProgress.config({
    barColors: {
      "0": baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  });
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>;
};

export { PrivateRoutes };
